import Vue from 'vue';
import Router from 'vue-router';
import { log } from '@/utils/logging';
import Cookies from 'js-cookie';
import { helpPageUrls, LoginTypes } from '@/utils/enums';
import store from '../store';
import i18n from '@/utils/i18n';
import { removeTokenAndPlayer } from '@/store/modules/player';
import RouterProvider from './routerProvider';
import { login } from '../utils/api';
import { ExternalWagerLoginTypes } from '../utils/enums';
import { isElectronContext } from '../utils/isElectron';

let routerProvider = new RouterProvider();
Vue.prototype.routerProvider = routerProvider;

const isElectron = isElectronContext() || typeof Epos_Android_Interface != 'undefined';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: routerProvider.getRoutesWithLocales(),
});

router.beforeEach(async (to, from, next) => {
  if (!store.state.settings.terminalInfo) {
    store.dispatch('settings/setAppLoading', true);
    if (to.query.userToken) {
      store.commit('player/setToken', to.query.userToken);
      store.commit('player/setLoginType', LoginTypes.Player);
      // store.dispatch("player/getPlayerLoginDetail")
    }
    let res;
    await store.dispatch('settings/getTerminalInfo', to.query);
    let terminalData = store.state.settings.terminalInfo;
    const defaultLanguage = JSON.parse(terminalData.brand_settings.location_settings.available_languages).find(
      _ => _.is_default,
    );
    store.commit('settings/setLanguageLoading', true);
    res = await store.dispatch('settings/getLocaleMessages');
    store.commit('settings/setLanguageLoading', false);
    let selectedLocale = store.state.settings.selectedLocale;
    let selectedLocaleCode =
      (selectedLocale && Object.keys(selectedLocale).length > 0 && selectedLocale.short_code) || defaultLanguage.code;
    i18n.setLocaleMessage(selectedLocaleCode, res.data[selectedLocaleCode]);
    //.dispatch('settings/setLocale', selectedLocaleCode);
    window.Locale = res.data;
    if (terminalData && terminalData.brand_settings) {
      store.dispatch('settings/setAppLoading', false);
    }

    if (to.query.userToken) {
      router.replace({
        ...router.currentRoute,
        query: {
          userToken: undefined,
        },
      });
    }
  }
  log('[ROUTER] viewing page: ' + to.path);
  const publicPages = [
    'index',
    'login',
    'register',
    'C',
    'sports',
    'sports.games',
    'sportsbook.games.all',
    'sports.props',
    'help',
    'refer',
    'contact',
    'bonus',
    'about',
    'bet-slip',
    'errorPage',
    'forgot-password',
    'reset-password',
    'racing',
    'terms-of-use',
    'casino',
    'casino.games',
    'history',
    'p',
    'start',
    'vcreditos-doc',
    'deposit-page',
    'customer-satisfaction-survey',
    'clerk-ticket-test',
  ];
  const clerkPages = [
    'clerk-deposit',
    'clerk-wager',
    'clerk-payout',
    'clerk-register-customer-payout',
    'clerk-loyalty',
  ];
  const authRequired = !publicPages.includes(to && to.matched && to.matched[0] && to.matched[0].name);
  const loggedIn = Cookies.get('PREF_JWT_TOKEN');
  const loginType = Cookies.get('LOGIN_TYPE');
  const isProduction = process.env.NODE_ENV === 'production';
  const isStaging = window.location.href.includes('engine-stg') || window.location.href.includes('engine-fv3');
  const isPreprod = window.location.href.includes('engine-preprod') || window.location.href.includes('ib-engine');
  const isStagingDev = window.location.href.includes('engine-dev');

  //ZENDESK CONTROLLER
  // const nonZendeskPages = [
  //   "bet-slip",
  // ]
  // if(to.matched.length && nonZendeskPages.includes(to.matched[0].name)){
  //   Vue.prototype.$zendeskController.hide()
  // }else {
  //   Vue.prototype.$zendeskController.create()
  //   $zopim.livechat.button.hide();
  // }
  //ZENDESK CONTROLLER END

  if (loggedIn && loginType === LoginTypes.Player && !store.state.player.player.PlayerAccount) {
    store.dispatch('settings/setAppLoading', true);

    let res = await store.dispatch('player/getPlayerLoginDetail');
    // const res = await playerService.getPlayerLoginDetails();
    // localStorage.setItem("PREF_PLAYER", JSON.stringify(res.data.Data.Player));
    let currentLocale = JSON.parse(store.state.settings.brandSettings.location_settings.available_languages).find(
      item => item.id == store.state.player.player.PlayerInfo.DGS.language,
    );
    store.commit('settings/setSelectedLocale', currentLocale ? currentLocale.short_code : null);
    store.dispatch('settings/setAppLoading', false);
    //await store.dispatch('player/getPlayerRolloverDetail');
  }
  if (
    !loggedIn &&
    ![ExternalWagerLoginTypes.DepositTicket, ExternalWagerLoginTypes.ClerkDepositTicket].includes(loginType)
  ) {
    if (loginType !== ExternalWagerLoginTypes.MobileScanCode) {
      let res = await removeTokenAndPlayer(true);
    }
    store.commit('player/setLogout');

    if (isStaging || isStagingDev) {
      if (authRequired) {
        return next('/login');
      }
    }

    //[TRIFECTA] TEMPORARY SOLUTION TO REDIRECT TO GUEST SITE IF UNAUTHORIZED IN PRODUCTION
    /*if (isProduction && !isElectron && !isStaging && !isStagingDev && !isPreprod) {
      const guestUrl = localStorage.getItem('guest_url');
      if (guestUrl) {
        window.location.href = guestUrl;
        return;
      }
      window.location.href = window.location.origin.replace('engine.', '');
      return;
    } else {*/
      if (authRequired) {
        return next('/login');
      }
    //}
  }
  if (clerkPages.includes(to.name)) {
    const clerkTypes = ['CLERK', 'CLERK_DEPOSIT_TICKET'];
    if (!clerkTypes.includes(loginType)) return next('/login');
  }

  if (to.matched && to.matched[0] && to.matched[0].name === 'help' && !isElectron) {
    const bookID = store.state.settings.brandSettings.book_id;
    const locale = store.state.settings.selectedLocale.short_code;
    const url = helpPageUrls[bookID][locale];
    window.open(url, '_blank');
    return;
  }

  let routeSwitch = routerProvider.routeSwitchControl(to);
  if (routeSwitch) {
    next(routeSwitch);
  }

  next();
});

router.afterEach(async (to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
